<template>
   <vs-row vs-justify="center">
    <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
      
      <vs-card>
        <div class="d-md-flex align-items-center pb-2">
        <h3 class="card-title mb-0">Inventory {{this.$route.params.ref}}</h3>
        <div class="ml-auto">
          <vs-button @click="backpage" color="danger" type="filled" class="mt-4 mt-md-0" icon="highlight_off" v-focus>
           Batal
          </vs-button>
        </div> 
        </div>
        <vs-alert v-if="errors.length" class="mb-3 mt-2"  color="danger">
            <b>Terdapat Kesalahan..</b>
            <ul class="common-list">
            <li v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
        </vs-alert>
        <div>
          <vs-row>
            <vs-col vs-lg="8" vs-xs="12" vs-sm="3">  
                <vs-select class="w-100 mt-4" label="KODE PERKIRAAN" ref="perkiraan" v-model="formdata.kode_perk">
                <vs-select-item
                    :key="index"
                    :value="item.kode_perk"
                    :text="parseNama(item.nama)"
                    v-for="(item,index) in optperkiraanInv"
                />
                </vs-select>
            </vs-col>
            <vs-col vs-lg="2" vs-xs="12" vs-sm="3">  
                <vs-input label="KODE BARANG" class="w-100 mt-4" ref="transval" v-model="formdata.kode_barang" /> 
            </vs-col>
            <vs-col vs-lg="2" vs-xs="12" vs-sm="3">  
                <vs-input label="SATUAN" class="w-100 mt-4" ref="transval" v-model="formdata.satuan" /> 
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col vs-lg="12" vs-xs="12" vs-sm="3">  
                <vs-input label="URAIAN" class="w-100 mt-4" ref="transval" v-model="formdata.uraian" /> 
            </vs-col>
            
          </vs-row>
        </div>
        <div class="btn-alignment mt-4">
          <vs-button color="success" type="filled" @click.stop.prevent="checkForm">Simpan</vs-button>
          <vs-button color="dark" @click="backpage" type="filled">Batal</vs-button>
        </div>
      </vs-card>
    </vs-col>
    
   </vs-row>
</template>

<script>
  /* eslint-disable no-console */
  /* eslint-disable no-case-declarations */

  

  export default {
    data: function () {
      return {
        // eslint-disable-next-line
        formdata: {
            kode_perk:'',
            kode_barang:'',
            uraian:'',
            satuan:'',
            isEdit: false,
            prevReferensi:''
        },
        optperkiraan:[],
        optperkiraanInv:[],
        errors:[],
        idtrans:0,
        inputUrl: '/api/item'
      }
    },
    methods:{
        backpage: function(){
            this.$router.go(-1);
        },
        parseNama: function(nama){
            var parts = nama.split('+');
            return parts[0].replace(/=/g, '\u00a0') + parts[1];        
        },
        getNamaperk: function(kode){
            let nama_perk = this.optperkiraan.find(x => x.kode_perk==kode).nama;
            let parts = nama_perk.split('+');
            return parts[1];
        },
        getAllData: function(){
            this.$http.get('/api/perkiraan').then(response => {
                //console.log(response.data);
                this.optperkiraan = response.data
                this.optperkiraanInv = this.optperkiraan.filter(function(kode){
                    if(kode.kode_perk.substring(0,2) == '15')
                        return true;
                })
            }).catch(error=>{
                //console.log(error);
            });
            //edit mode init data
            if(this.$route.params.ref != null){
                this.formdata.isEdit = true
                this.$http.get(this.inputUrl+"/"+this.$route.params.ref).then(response => {
                    console.log(response.data)
                    //this.formdata.datatrans = response.data;
                    const keys = Object.keys(response.data)
                    console.log(keys)
                    var self = this
                    for(const key of keys){
                        //console.log(key)
                        if (this.formdata.hasOwnProperty(key))
                            this.formdata[key] = response.data[key]
                        if(key == 'id'){
                            console.log('kode masuk')
                            this.formdata.prevReferensi = response.data[key]
                        }
                            
                    }
                }).catch(error=>{
                    console.log(error)
                    this.$vs.notify({title:'Error',text:'Gagal inisiasi data, silahkan coba lagi...',color:'danger'})
                });
            }
            //edit mode init data

            this.formdata.pemohon_id = this.$store.getters.getUserId
        },
        checkForm:function(e) {
            this.errors = [];
            //cek dari client dulu...
            
            if(this.formdata.kode_perk == ''){
                this.errors.push("Kode Perkiraan belum terisi...")
            }

            if(this.formdata.kode_barang == ''){
                this.errors.push("Kode Barang belum terisi...")
            }

            if(this.formdata.uraian == ''){
                this.errors.push("Uraian belum terisi...")
            }

            if(this.formdata.satuan == ''){
                this.errors.push("Satuan belum terisi...")
            }

            if(this.errors.length > 0){
                this.handleError(this.error,'local')
            }
            else{
                this.$vs.loading({'type':'radius'})
                this.$http.post(this.inputUrl,{
                    formdata : this.formdata
                }).then(response => {
                    console.log(response);
                    this.handleSuccess();
                    //
                }).catch(error=>{
                    console.log(error.response)
                    this.handleError(error)
                })
            }
        },
        handleError: function(error,type=''){
            if(type != 'local'){
                if (error.response != null){
                    let status = error.response.status
                    console.log(status)
                    switch(status){
                        case 422 :
                            const keys = Object.keys(error.response.data.errors)
                            //console.log(keys);
                            for(const key of keys){
                                //console.log(key)
                                //console.log(error.response.data.errors[key][0])
                                this.errors.push(error.response.data.errors[key][0])
                            }
                        break
                        case 500 :
                            this.errors.push('Internal server error.. silahkan hubungi administrator')
                            break
                        default:
                            this.errors.push('Terjadi error di server..')
                            break
                    }
                }
                else
                    this.errors.push('Terjadi error di server..')
            }
            console.log('handle error')
            this.notify()
            this.$vs.loading.close()
        },
        handleSuccess: function(){
            this.$vs.loading.close()
            this.$vs.notify({title:'Success',text:'Data berhasil disimpan..',color:'success'})
            //this.$router.push('/jurnal/ju');
            this.$router.push({name : 'inventorylist'});
        },
        notify: function(){
            this.$vs.notify({
                title:'Gagal Menyimpan Data',
                text:'Click untuk melihat',
                color:'danger',
                fixed:false,
                icon: 'warning',
                click:()=>{
                    window.scrollTo(0,0);
                },
            })
        }
    },
    watch:{
        'formdata.module_id': function(){
            let mod_id = this.formdata.module_id
            if(mod_id != 1)
                this.formdata.jenis = 0
            let mod_name = this.optmodule.filter(item => item.id == mod_id).map(item => item.controller).join('');
            this.formdata.mod_name = mod_name
        },
    },
    mounted: function () {
        this.getAllData();
    },
  }
</script>